import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const FlyingCart = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const handleFly = (e) => {
      const { startX, startY, image } = e.detail;
      const cartEl = document.getElementById("cart-nav-tab");
      if (!cartEl) return;
      const rect = cartEl.getBoundingClientRect();
      const targetX = rect.left + rect.width / 2;
      const targetY = rect.top + rect.height / 2;

      const id = Date.now() + Math.random();
      setItems((prev) => [
        ...prev,
        { id, startX, startY, targetX, targetY, image }
      ]);
    };

    window.addEventListener("fly-to-cart", handleFly);
    return () => window.removeEventListener("fly-to-cart", handleFly);
  }, []);

  const handleAnimationComplete = (id) => {
    setItems((prev) => prev.filter((item) => item.id !== id));
    window.dispatchEvent(new CustomEvent("cart-bounce"));
  };

  return (
    <div className="fixed inset-0 pointer-events-none z-[99999] overflow-hidden">
      <AnimatePresence>
        {items.map((item) => (
          <motion.img
            key={item.id}
            src={item.image}
            alt="flying-item"
            className="fixed w-14 h-14 rounded-full object-cover shadow-2xl border-2 border-white z-[99999]"
            initial={{
              left: item.startX - 28,
              top: item.startY - 28,
              scale: 1,
              opacity: 1
            }}
            animate={{
              left: [
                item.startX - 28,
                (item.startX + item.targetX) / 2 - 28,
                item.targetX - 28
              ],
              top: [
                item.startY - 28,
                Math.min(item.startY, item.targetY) - 160,
                item.targetY - 28
              ],
              scale: [1, 0.7, 0.2],
              opacity: [1, 1, 0]
            }}
            transition={{
              duration: 0.8,
              ease: "easeInOut"
            }}
            onAnimationComplete={() => handleAnimationComplete(item.id)}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default FlyingCart;
